import { useTranslation } from 'react-i18next'

import { Button, Text } from '@reveni-io/reveni-ui'

import WhiteLabelThemeProvider from '@/configuration/components/WhiteLabelThemeProvider/WhiteLabelThemeProvider'

import { getErrorDialogMessage, getErrorDialogTitle } from './helpers'
import * as Styles from './styles'

const ErrorDialogsPreview = ({ activeErrorDialog, customCopies, lang, merchantInfo, isActive }) => {
  const { t } = useTranslation()
  const copies = isActive ? customCopies : {}
  const title = getErrorDialogTitle(activeErrorDialog, copies, lang)
  const message = getErrorDialogMessage(activeErrorDialog, copies, lang, merchantInfo)

  return (
    <Styles.Container>
      <WhiteLabelThemeProvider>
        <Styles.PreviewContent>
          <Styles.DialogCard>
            <Styles.DialogTitle>
              <Text type="bodyMBold">{title}</Text>
            </Styles.DialogTitle>
            {/* nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml */}
            <Styles.DialogMessage dangerouslySetInnerHTML={{ __html: message }} />
            <Styles.DialogActions>
              <Button fullWidth>{t('Aceptar')}</Button>
            </Styles.DialogActions>
          </Styles.DialogCard>
        </Styles.PreviewContent>
      </WhiteLabelThemeProvider>
    </Styles.Container>
  )
}

export default ErrorDialogsPreview
